import { Box, Button, Icon, Text, useColorModeValue } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { Link, useLocation } from "react-router";

type PageName = string;

export type SidebarButtonProps = {
    pageName: PageName;
    iconFill?: IconType;
    iconOutline: IconType;
    text: string;
    close?: () => void;
    small?: boolean;
};

export const SidebarButton = ({ pageName, iconFill, iconOutline, text, close, small }: SidebarButtonProps) => {
    iconFill = iconFill || iconOutline;

    const location = useLocation();
    const openedPage = location.pathname.split("/")[1];
    const isOpen = openedPage === pageName;
    const activeColor = useColorModeValue("brand.500", "brand.400");

    // NB: the icon goes into `children`, not `leftIcon`, because of OOM issues with Chakra 2 and SSR.
    return (
        <Button
            size={small ? "sm" : "md"}
            as={Link}
            to={pageName.includes(":") ? pageName : `/${pageName}`}
            color={isOpen ? activeColor : "currentcolor"}
            variant="link"
            justifyContent="flex-start"
            _focus={{
                color: isOpen ? activeColor : "currentcolor",
            }}
            _hover={{
                textDecoration: "none",
            }}
            onClick={close}
        >
            <Box as="span" display="inline-flex" mr={2} fontSize="20px" aria-hidden>
                <Icon as={isOpen ? iconFill : iconOutline} />
            </Box>
            <Text
                fontSize={small ? "sm" : "xl"}
                fontWeight={"medium"}
                borderBottom="solid transparent 1.5px"
                borderBottomColor={openedPage === pageName ? "currentColor" : "transparent"}
                _hover={
                    small
                        ? {}
                        : {
                              borderBottomColor: "currentColor",
                          }
                }
            >
                {text}
            </Text>
        </Button>
    );
};
